import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Landing from "@/pages/Landing";

function App() {
  return (
    <div className="App bg-onyx text-cream">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#181B15",
            color: "#EDE6D3",
            border: "1px solid rgba(237,230,211,0.15)",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

export default App;
